import { PermissionSet } from 'api/models';
import { FieldPermission, ProjectPermissionTypes } from 'api/permissions';
import { useUser } from 'hooks/use-user';

export const useUserPermission = () => {
  const user = useUser();

  return user.permissions;
};

type IUserFieldsPermission =
  | [Array<FieldPermission>]
  | [Array<FieldPermission>, Array<FieldPermission>];

export const useUserFieldsPermission = (
  projectId?: number,
): IUserFieldsPermission => {
  const userPermission = useUserPermission();

  const accountFieldsPermission = userPermission.fields;

  if (projectId) {
    const project = userPermission.projects[projectId];
    const projectFieldsPermissions = project?.fields || [];

    return [accountFieldsPermission, projectFieldsPermissions];
  }

  return [accountFieldsPermission];
};

export const useUserProjectPermissions = (projectId?: number) => {
  const userPermission = useUserPermission();

  let permissionSet: PermissionSet | undefined;
  let allPermissions: ProjectPermissionTypes[] | undefined;

  if (projectId) {
    const projectPermission = userPermission.projects[projectId];

    permissionSet = projectPermission?.permissionSet;

    allPermissions = projectPermission?.project || [];
  }

  return { permissionSet, allPermissions };
};
